var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.24 7.22006V16.7901C20.24 18.7501 18.11 19.9801 16.41 19.0001L12.26 16.6101L8.10996 14.2101C6.40996 13.2301 6.40996 10.7801 8.10996 9.80006L12.26 7.40006L16.41 5.01006C18.11 4.03006 20.24 5.25006 20.24 7.22006Z",
    fill: "#434343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76001 18.9301C3.35001 18.9301 3.01001 18.5901 3.01001 18.1801V5.82007C3.01001 5.41007 3.35001 5.07007 3.76001 5.07007C4.17001 5.07007 4.51001 5.41007 4.51001 5.82007V18.1801C4.51001 18.5901 4.17001 18.9301 3.76001 18.9301Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousVideo);
export default __webpack_public_path__ + "static/media/previous-video.5121e0d30966f5b89ddbd71eceb552c4.svg";
export { ForwardRef as ReactComponent };